import type {RouteRecordRaw} from "vue-router";
import {route as Incoming, routeName as incomingRouteName} from "./incoming";
import {route as Outgoing} from "./outgoing";
import {route as CreateDocument} from './create';
import {route as EditDocument} from './edit';
import {route as DocumentInfo} from './info';
import {route as DocumentDraft} from './draft';
import {route as DocumentTrash} from './trash';
import {route as CabinetTariffs} from './tariffs';
import {route as CabinetMobile, routeName as cabinetMobileRouteName} from './main_mobile';
import {route as CabinetService} from './services_mobile';
import {route as NotificationMobile} from './notification';

import {screen_breakpoint_md} from "@/shared/lib/utils/platform";

import FolderIcon from "@/app/assets/icons/folders.vue";
import BriefcaseIcon from "@/app/assets/icons/briefcase_outline.vue";

export const routeName = 'Cabinet';

export const route: RouteRecordRaw = {
    name: routeName,
    path: '/cabinet',
    component: () => import('@/pages/Cabinet'),
    beforeEnter: (to, _, next) => {
        if (to.name === routeName) {
            if (window.innerWidth >= screen_breakpoint_md) {
                return next({name: incomingRouteName})
            }
            return next({name: cabinetMobileRouteName});
        }
        next();
    },
    children: [
        Incoming,
        Outgoing,
        CreateDocument,
        EditDocument,
        DocumentInfo,
        DocumentDraft,
        DocumentTrash,
        CabinetTariffs,
        CabinetMobile,
        CabinetService,
        NotificationMobile,
        {
            name: 'CopyDocument',
            path: 'copy/:id(\\d+)',
            component: () => import('@/pages/CopyDocument'),
            props: route => ({ id: Number(route.params.id) }),
            meta: {
                isHide: true,
            }
        },
        {
            name: 'Folder',
            path: 'folder/:id?',
            component: () => import('@/pages/Folders'),
            props: true,
            meta: {
                title: 'folders',
                icon: FolderIcon,
                isNavTab: true,
                divider: 'before',
            },
        },
        {
            name: 'Counterparty',
            path: 'counterparty',
            component: () => import('@/pages/Counterparty'),
            props: true,
            meta: {
                title: 'counterparty',
                icon: BriefcaseIcon,
                isNavTab: true,
                isNew: false,
            },
        },
        {
            name: 'PaymentHistory',
            path: 'payments',
            component: () => import('@/pages/PaymentHistory'),
            meta: {
                isHide: true,
            },
        },
        {
            path: ':pathMatch(.*)*',
            name: 'NotFoundInCabinet',
            component: () => import("@/pages/NotFound"),
            props: {
                cabinet: true,
            },
            meta: {
                isHide: true,
            }
        },
    ]
};
